import React from 'react';

import styles from "../styles/tabs.module.scss";
import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Link} from "../../link/link";

export class TabProps extends BaseProps {
  onClick: Function;
  label: String;
  isActive: Boolean;
}

export const Tab = ({tab, isActive, onClick, className, activeClassName}: TabProps) => {
  const {name,linkModel} = tab;

  const buttonProps = {
    className: classNames(styles.tab, className, {[activeClassName? activeClassName : styles.active]: isActive}),
    onClick: () => {onClick && onClick(tab); return true},
    model: linkModel
  };

  return (
    <Link {...buttonProps}>
      {name}
    </Link>
  );
}